module.exports = __webpack_public_path__ + "static/media/weight1.1be70a7a.webp";